// MUI
import { Box, Snackbar, Alert } from '@mui/material';

export default function SnackbarComp({ clickedBtn, handleClose, open }) {

    const alertContent = clickedBtn === "check" ? "تم إنجاز المهمة"
        :
        clickedBtn === "uncheck" ? "المهمة الآن غير منجزة"
            :
            clickedBtn === "update" ? "تم تعديل المهمة"
                :
                "تم حذف المهمة";

    return (
        <Box>
            <Snackbar open={open} autoHideDuration={3000} onClose={handleClose}>
                <Alert
                    onClose={handleClose}
                    severity="success"
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {alertContent}
                </Alert>
            </Snackbar>
        </Box>
    );
}
